import React from "react";
import PropTypes from "prop-types";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

// Scoped replacement for the two reviewed tables. mui-datatables overrides the
// Select menu ID without updating aria-controls. Bind both to the same ID and
// mount the popup into main through MUI's portal/container API. Disabling only
// the portal lets ModalManager hide #app, including its nested popup.
const AccessibleTableFooter = ({
  count,
  rowsPerPage,
  page,
  changeRowsPerPage,
  changePage,
  textLabels,
  rowsPerPageOptions = [10, 15, 100],
}) => (
  <TableFooter sx={{ "@media print": { display: "none" } }}>
    <TableRow>
      <TablePagination
        count={count}
        rowsPerPage={rowsPerPage}
        page={Math.max(0, Math.min(page, Math.ceil(count / rowsPerPage) - 1))}
        labelRowsPerPage={textLabels.rowsPerPage}
        labelDisplayedRows={({ from, to, count: total }) =>
          `${from}-${to} ${textLabels.displayRows} ${total}`
        }
        backIconButtonProps={{
          id: "pagination-back",
          "data-testid": "pagination-back",
          "aria-label": textLabels.previous,
          title: textLabels.previous || "",
        }}
        nextIconButtonProps={{
          id: "pagination-next",
          "data-testid": "pagination-next",
          "aria-label": textLabels.next,
          title: textLabels.next || "",
        }}
        SelectProps={{
          id: "pagination-input",
          SelectDisplayProps: {
            id: "pagination-rows",
            "data-testid": "pagination-rows",
            "aria-controls": "pagination-menu-list",
          },
          MenuProps: {
            id: "pagination-menu",
            "data-testid": "pagination-menu",
            container: () => document.querySelector("main"),
            MenuListProps: {
              id: "pagination-menu-list",
              "data-testid": "pagination-menu-list",
            },
          },
        }}
        rowsPerPageOptions={rowsPerPageOptions}
        onPageChange={(_, nextPage) => changePage(nextPage)}
        onRowsPerPageChange={(event) =>
          changeRowsPerPage(Number(event.target.value))
        }
      />
    </TableRow>
  </TableFooter>
);

AccessibleTableFooter.propTypes = {
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  changeRowsPerPage: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  textLabels: PropTypes.object.isRequired,
  rowsPerPageOptions: PropTypes.array,
};
// The pinned mui-datatables callback passes page BEFORE rowsPerPage.
export const renderAccessibleTableFooter = (
  count,
  page,
  rowsPerPage,
  changeRowsPerPage,
  changePage,
  textLabels,
  rowsPerPageOptions
) => (
  <AccessibleTableFooter
    {...{
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels,
      rowsPerPageOptions,
    }}
  />
);

export default AccessibleTableFooter;
